class ThumbnailSliderComponent extends HTMLElement {
  constructor() {
    super();
    console.log('ThumbnailSliderComponent: Constructor called');
    this.domCache = {
      thumbnailGrid: this.querySelector('.thumbnail-grid'),
      slideshow: this.querySelector('.slideshow-container'),
      slides: Array.from(this.querySelectorAll('[id^="Slide-"]')),
      thumbnails: Array.from(this.querySelectorAll('.thumbnail-item')),
      slideshowNav: this.querySelector('.slideshow-nav-wrapper'),
      prevButton: this.querySelector('.slideshow-nav--prev'),
      nextButton: this.querySelector('.slideshow-nav--next'),
      closeButton: this.querySelector('.slideshow-close'),
      gridItemsParent: this.querySelector('.thumbnail-grid ul')
    };
    this.activeIndex = null;
    this.itemsPerRow = this.getItemsPerRow();

    console.log('ThumbnailSliderComponent: Initial properties', {
      thumbnailGridExists: !!this.domCache.thumbnailGrid,
      slideshowExists: !!this.domCache.slideshow,
      numberOfSlides: this.domCache.slides.length,
      numberOfThumbnails: this.domCache.thumbnails.length,
      prevButtonExists: !!this.domCache.prevButton,
      nextButtonExists: !!this.domCache.nextButton,
      closeButtonExists: !!this.domCache.closeButton,
      itemsPerRow: this.itemsPerRow
    });

    this.init();
  }

  getItemsPerRow() {
    return parseInt(this.dataset.columnsDesktop) || 4;
  }

  init() {
    console.log('ThumbnailSliderComponent: Initializing');
    this.hideAllSlides();
    this.setupEventListeners();
    this.setupVideoHandlers();
    this.logGridStructure();
  }

  setupEventListeners() {
    console.log('ThumbnailSliderComponent: Setting up event listeners');
    this.domCache.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => this.showSlide(index));
    });
    this.domCache.prevButton.addEventListener('click', () => this.showPrevSlide());
    this.domCache.nextButton.addEventListener('click', () => this.showNextSlide());
    this.domCache.closeButton.addEventListener('click', () => this.closeSlide());
  }

  showSlide(index) {
    this.domCache.slideshowNav.style.opacity = '1';
    console.log(`ThumbnailSliderComponent: Showing slide at index ${index}`);
    console.log('Current scroll position:', window.pageYOffset);
    if (this.activeIndex === index) {
      console.log('ThumbnailSliderComponent: Clicked active thumbnail, no action needed');
      return;
    }
  
    const newSlide = this.domCache.slides[index];
    if (!newSlide) {
      console.error(`No slide found at index ${index}`);
      return;
    }
  
    const oldRowIndex = this.activeIndex !== null ? Math.floor(this.activeIndex / this.itemsPerRow) : -1;
    const newRowIndex = Math.floor(index / this.itemsPerRow);
    const isNewRow = oldRowIndex !== newRowIndex;
  
    console.log('Row information:', { oldRowIndex, newRowIndex, isNewRow });
  
    if (isNewRow) {
      console.log('Opening slide on a new row');
      this.closeAndOpenSlide(index);
    } else {
      console.log('Transitioning slides on the same row');
      this.transitionSlides(index);
    }
  
    this.activeIndex = index;
    this.updateThumbnailStates();
    this.lazyLoadImages(newSlide);
    
    requestAnimationFrame(() => {
      console.log('requestAnimationFrame callback executed');
      let targetElement = this.querySelector('.banner:after') || 
                          this.querySelector('.slideshow') ||
                          this.querySelector('.slideshow-container') ||
                          this.querySelector('.grid__item--full-width');
      
      console.log('Target element for scrolling:', targetElement);
      
      if (targetElement) {
        console.log(`ThumbnailSliderComponent: Scrolling to center for`, targetElement);
        setTimeout(() => {
          this.scrollToCenter(targetElement);
        }, 400);
      } else {
        console.log(`ThumbnailSliderComponent: No suitable target found, scrolling to thumbnail ${index}`);
        this.scrollToCenter(this.domCache.thumbnails[index]);
      }
    });
    
    this.logGridStructure();
  }
  
  hideAllSlides() {
    this.domCache.slideshowNav.style.opacity = '0';
    console.log('ThumbnailSliderComponent: Hiding all slides');
    this.domCache.slides.forEach(slide => {
      slide.style.maxHeight = '0';
      slide.style.opacity = '0';
      setTimeout(() => {
        slide.style.display = 'none';
      }, 300); // This should match the transition duration in CSS
    });
  }

  closeAndOpenSlide(newIndex) {
    console.log(`ThumbnailSliderComponent: Closing current slide and opening new slide at index ${newIndex}`);
    const currentSlide = this.activeIndex !== null ? this.domCache.slides[this.activeIndex] : null;
    const newSlide = this.domCache.slides[newIndex];

    if (currentSlide) {
      this.animateSlideClose(currentSlide, () => {
        console.log('Current slide closed, updating full-width row');
        this.updateFullWidthRow(newIndex);
        this.animateSlideOpen(newSlide);
      });
    } else {
      console.log('No current slide, directly opening new slide');
      this.updateFullWidthRow(newIndex);
      this.animateSlideOpen(newSlide);
    }
  }

  transitionSlides(newIndex) {
    console.log(`ThumbnailSliderComponent: Transitioning to slide at index ${newIndex}`);
    const currentSlide = this.domCache.slides[this.activeIndex];
    const newSlide = this.domCache.slides[newIndex];

    currentSlide.classList.remove('active');
    currentSlide.classList.add('transitioning-out');

    newSlide.style.display = 'block';
    newSlide.style.maxHeight = '0';
    newSlide.style.opacity = '0';

    requestAnimationFrame(() => {
      console.log('Animating new slide open');
      newSlide.classList.add('active');
      newSlide.style.maxHeight = '1000px';
      newSlide.style.opacity = '1';
    });

    setTimeout(() => {
      console.log('Finishing slide transition');
      currentSlide.style.display = 'none';
      currentSlide.classList.remove('transitioning-out');
    }, 300);
  }

  animateSlideClose(slide, callback) {
    console.log('ThumbnailSliderComponent: Animating slide close');
    slide.classList.remove('active');
    slide.classList.add('transitioning-out');
    slide.style.maxHeight = '0';
    slide.style.opacity = '0';

    setTimeout(() => {
      slide.style.display = 'none';
      slide.classList.remove('transitioning-out');
      console.log('Slide close animation completed');
      if (callback) callback();
    }, 300);
  }

  animateSlideOpen(slide) {
    console.log('ThumbnailSliderComponent: Animating slide open');
    slide.style.display = 'block';
    slide.style.maxHeight = '0';
    slide.style.opacity = '0';

    requestAnimationFrame(() => {
      console.log('Opening slide animation frame');
      slide.classList.add('active');
      slide.style.maxHeight = '1000px';
      slide.style.opacity = '1';
    });
  }

  updateFullWidthRow(index) {
    console.log(`ThumbnailSliderComponent: Updating full-width row for index ${index}`);
    const rowIndex = Math.floor(index / this.itemsPerRow);
    const insertPosition = (rowIndex + 1) * this.itemsPerRow;
    
    const existingFullWidthItems = this.querySelectorAll('.grid__item--full-width');
    existingFullWidthItems.forEach(item => {
      console.log('Removing existing full-width item');
      item.remove();
    });

    const fullWidthItem = document.createElement('li');
    fullWidthItem.className = 'grid__item grid__item--full-width';
    fullWidthItem.appendChild(this.domCache.slideshow);

    const gridItems = Array.from(this.domCache.gridItemsParent.children);
    console.log(`Total grid items before insertion: ${gridItems.length}`);

    if (insertPosition < gridItems.length) {
      console.log(`Inserting full-width item before item at position ${insertPosition}`);
      this.domCache.gridItemsParent.insertBefore(fullWidthItem, gridItems[insertPosition]);
    } else {
      console.log('Appending full-width item to end of grid');
      this.domCache.gridItemsParent.appendChild(fullWidthItem);
    }

    console.log(`Full-width item inserted. New total grid items: ${this.domCache.gridItemsParent.children.length}`);
  }

  updateThumbnailStates() {
    console.log('ThumbnailSliderComponent: Updating thumbnail states');
    this.domCache.thumbnails.forEach((thumbnail, index) => {
      thumbnail.classList.toggle('active', index === this.activeIndex);
    });
  }

  showPrevSlide() {
    console.log('ThumbnailSliderComponent: Showing previous slide');
    const newIndex = (this.activeIndex - 1 + this.domCache.slides.length) % this.domCache.slides.length;
    this.showSlide(newIndex);
  }

  showNextSlide() {
    console.log('ThumbnailSliderComponent: Showing next slide');
    const newIndex = (this.activeIndex + 1) % this.domCache.slides.length;
    this.showSlide(newIndex);
  }

  closeSlide() {
    this.domCache.slideshowNav.style.opacity = '0';
    console.log('ThumbnailSliderComponent: Closing slide');
    if (this.activeIndex !== null) {
      const activeSlide = this.domCache.slides[this.activeIndex];
      this.animateSlideClose(activeSlide, () => {
        const fullWidthItem = this.querySelector('.grid__item--full-width');
        if (fullWidthItem) {
          console.log('Removing full-width item');
          fullWidthItem.remove();
        }
        console.log(`Scrolling to center for thumbnail ${this.activeIndex}`);
        this.scrollToCenter(this.domCache.thumbnails[this.activeIndex]);
        this.activeIndex = null;
        this.updateThumbnailStates();
        this.logGridStructure();
      });
    }
  }

  scrollToCenter(element) {
    console.log('ThumbnailSliderComponent: Scrolling element to center', element);
    if (!element) {
      console.warn('No element provided to scroll to center');
      return;
    }
    
    const elementRect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    console.log('Element dimensions:', {
      top: elementRect.top,
      bottom: elementRect.bottom,
      height: elementRect.height
    });
    console.log('Viewport height:', viewportHeight);
    console.log('Current scroll position:', window.pageYOffset);
    
    // Calculate the ideal position to center the element
    const idealScrollPosition = window.pageYOffset + elementRect.top - (viewportHeight / 2) + (elementRect.height / 2);
    
    // Check if we're already very close to the ideal position
    const scrollTolerance = 50; // pixels
    const currentScrollPosition = window.pageYOffset;
    
    if (Math.abs(currentScrollPosition - idealScrollPosition) > scrollTolerance) {
      console.log(`Scrolling to position ${idealScrollPosition}`);
      this.smoothScroll(idealScrollPosition, 1000);
    } else {
      console.log('Already close to ideal scroll position, no scroll needed');
    }
  }

  smoothScroll(targetPosition, duration) {
    console.log(`Smooth scrolling from ${window.pageYOffset} to ${targetPosition}`);
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
      else console.log(`Smooth scroll completed. Final position: ${window.pageYOffset}`);
    }

    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }

  lazyLoadImages(slide) {
    console.log('ThumbnailSliderComponent: Lazy loading images');
    const lazyImages = slide.querySelectorAll('img[loading="lazy"]');
    lazyImages.forEach(img => {
      if (img.dataset.src) {
        console.log(`Loading image ${img.dataset.src}`);
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    });
  }

  setupVideoHandlers() {
    this.domCache.thumbnails.forEach(thumbnail => {
      const videoWrapper = thumbnail.querySelector('.thumbnail-video-wrapper');
      const video = thumbnail.querySelector('.thumbnail-video');
      if (video) {
        thumbnail.addEventListener('mouseenter', () => {
          videoWrapper.style.opacity = '1';
          video.play();
        });
        thumbnail.addEventListener('mouseleave', () => {
          videoWrapper.style.opacity = '0';
          video.pause();
          video.currentTime = 0;
        });
      }
    });
  }
  
  logGridStructure() {
    console.log('ThumbnailSliderComponent: Current grid structure:');
    if (this.domCache.gridItemsParent) {
      Array.from(this.domCache.gridItemsParent.children).forEach((child, index) => {
        console.log(`  Child ${index}: ${child.className}`);
      });
    } else {
      console.log('  Could not find parent ul element');
    }
  }
}

customElements.define('thumbnail-slider-component', ThumbnailSliderComponent);

console.log('ThumbnailSliderComponent: Component defined');